// extracted by mini-css-extract-plugin
module.exports = {"container":"ATdgA4jJk8PwrQONTUXg9"};